<template>
  <div style="background-color: #f6f6f6; height: 100vh;">
    <template v-if="loader">
      <Loader />
    </template>
    <div>teste</div>
  </div>
</template>

<script>
import Loader from '@/components/Loader/Loader.vue';

export default {
  name: 'Oauth',
  data() {
    return {
      loader: true,
    };
  },
  components: {
    Loader,
  },
  mounted() {
    this.saveAuth();
  },
  methods: {
    async saveAuth() {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        const params = {
          code: this.$route.query.code,
        };
        await this.$http.post('/v1/quickbooks/save-authorization', params, { headers });
        this.$router.push('/');
      } catch (e) {
        console.error('error saveAuth', e);
      }
    },
  },
};
</script>

<style>

</style>
